/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import config from '@/config'
// import Deliverer from '@jojosz/config-deliverer'
import i18n from './i18n'

const { env } = config
let tempEnv = env
if (!['fat', 'dev', 'uat', 'pro'].includes(env)) {
  tempEnv = 'pro'
}

Vue.config.productionTip = false

// import toastRegistry from 'components/Common/Toast'

// Vue.use(toastRegistry)
new Vue({
  render: h => h(App)
}).$mount('#app')

// 国际化
i18n()

